export default "__VITE_ASSET__tIgo0qg8__"